/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SegmentsGetSegmentThumbnailQueryResponse, SegmentsGetSegmentThumbnailPathParams, SegmentsGetSegmentThumbnail400, SegmentsGetSegmentThumbnail401, SegmentsGetSegmentThumbnail403, SegmentsGetSegmentThumbnail404 } from "../models/SegmentsGetSegmentThumbnail";

export function getSegmentsGetSegmentThumbnailUrl(station: SegmentsGetSegmentThumbnailPathParams["station"], segment: SegmentsGetSegmentThumbnailPathParams["segment"]) {
  const res = { method: 'GET', url: `/segments/v1/stations/${station}/segments/${segment}/thumbnail` as const }
  return res
}

/**
 * @description Returns the thumbnail URL and metadata for a video segment identified by its start timestamp.
 * @summary Get thumbnail for a single segment
 * {@link /segments/v1/stations/:station/segments/:segment/thumbnail}
 */
export async function segmentsGetSegmentThumbnail(station: SegmentsGetSegmentThumbnailPathParams["station"], segment: SegmentsGetSegmentThumbnailPathParams["segment"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SegmentsGetSegmentThumbnailQueryResponse, ResponseErrorConfig<SegmentsGetSegmentThumbnail400 | SegmentsGetSegmentThumbnail401 | SegmentsGetSegmentThumbnail403 | SegmentsGetSegmentThumbnail404>, unknown>({ method : "GET", url : getSegmentsGetSegmentThumbnailUrl(station, segment).url.toString(), ... requestConfig })
  return res.data
}